import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../axiosConfig";
import { toast } from "react-toastify";
import { GoogleGenAI } from "@google/genai";
import { IoClose } from "react-icons/io5";
import EmployeeProfileDirectory from "./EmployeeProfileDirectory";

const ProvideInfoEmployee = () => {
  const [positions, setPositions] = useState([]);
  const [areas, setAreas] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedWard, setSelectedWard] = useState("");
  const [detailedAddress, setDetailedAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  const [provinces2, setProvinces2] = useState([]);
  const [districts2, setDistricts2] = useState([]);
  const [wards2, setWards2] = useState([]);
  const [selectedProvince2, setSelectedProvince2] = useState("");
  const [selectedDistrict2, setSelectedDistrict2] = useState("");
  const [selectedWard2, setSelectedWard2] = useState("");
  const [detailedAddress2, setDetailedAddress2] = useState("");

  const [isExtracting, setIsExtracting] = useState(false);
  const [isFront, setIsFront] = useState(true);
  const [isBack, setIsBack] = useState(true);
  const [cardType, setCardType] = useState({ front: null, back: null });

  const [fileFront, setFileFront] = useState(null);
  const [previewUrlFront, setPreviewUrlFront] = useState(null);
  const [fileBack, setFileBack] = useState(null);
  const [previewUrlBack, setPreviewUrlBack] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  /** Bước đầu: cùng giao diện trang danh mục hồ sơ; bấm Tiếp tục mới vào form finish. */
  const [showProfileIntro, setShowProfileIntro] = useState(true);

  const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
  const model = "gemini-2.5-flash-lite";

  // Chuẩn hóa họ tên: viết hoa chữ cái đầu mỗi từ từ dữ liệu nhận về
  const capitalizeName = (rawName) => {
    if (!rawName || typeof rawName !== 'string') return '';
    return rawName
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ''))
      .join(' ');
  };

  // Hàm xử lý khi đang nhập: giữ lại khoảng trắng cuối để người dùng có thể tiếp tục nhập
  const capitalizeNameWhileTyping = (rawName) => {
    if (!rawName || typeof rawName !== 'string') return '';
    // Kiểm tra xem có khoảng trắng cuối không
    const hasTrailingSpace = rawName.endsWith(' ');
    const trimmed = rawName.toLowerCase().replace(/\s+/g, ' ').trim();
    const capitalized = trimmed
      .split(' ')
      .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ''))
      .join(' ');
    // Giữ lại khoảng trắng cuối nếu có
    return hasTrailingSpace ? capitalized + ' ' : capitalized;
  };

  const validateCCCD = (cccd) => {
    const s = cccd == null ? "" : String(cccd).trim();
    if (!s) return "Vui lòng nhập số căn cước công dân.";
    if (!/^\d{12}$/.test(s)) return "Số CCCD phải đúng 12 chữ số.";
    return "";
  };

  const formatDateVN = (dateTime) => {
    if (!dateTime) return ""; // Kiểm tra nếu không có giá trị, trả về chuỗi rỗng
    return dateTime.split(" ")[0]; // Tách chuỗi tại khoảng trắng và lấy phần đầu tiên (YYYY-MM-DD)
  };
  const [formData, setFormData] = useState({
    application_date: new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Ho_Chi_Minh",
    }),
    name: "",
    birthday: "",
    position: "",
    email: "",
    phone: "",
    sex: "",
    shift_id: "",
    area_id: "",
    start: "",
    mst: "",
    cmnd: "",
    cccd: "",
    date_range: "",
    cmnd_front: "",
    cmnd_back_side: "",
    temporary_address: "",
    permanent_address: "",
    issued_by: "CTCCS QLHCVTTXH",
    recuitment_position_id: "",
    bank_name: "",
    bank_number: "",
    bank_account_name: "",
  });
  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue =
      name === "name" ? capitalizeNameWhileTyping(value) : value;
    if (name === "cccd") {
      processedValue = value.replace(/\D/g, "").slice(0, 12);
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: processedValue,
    }));
  };

  // Handle radio button changes
  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // handle form field address changes
  const handleAddressChange = (e) => {
    setDetailedAddress(e.target.value);
  };
  // submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (loading == true) {
      return;
    }

    if ((formData.cmnd_front ?? "") == "") {
      toast.error("Vui lòng tải ảnh mặt trước CCCD/CMND.");
      return;
    }

    if ((formData.cmnd_back_side ?? "") == "") {
      toast.error("Vui lòng tải ảnh mặt sau CCCD/CMND.");
      return;
    }

    const cccdError = validateCCCD(formData.cccd);
    if (cccdError) {
      toast.error(cccdError);
      return;
    }

    setLoading(true);

    const dataSend = {
      name: capitalizeName(formData.name),
      birthday: formData.birthday,
      position: formData.position,
      email: formData.email,
      phone: formData.phone,
      sex: formData.sex,
      shift_id: formData.shift_id,
      area_id: formData.area_id,
      start: formData.start,
      mst: formData.mst,
      cmnd: formData.cmnd,
      cccd: formData.cccd,
      date_range: formData.date_range,
      cmnd_front: formData.cmnd_front,
      cmnd_back_side: formData.cmnd_back_side,
      temporary_address:
        detailedAddress == ""
          ? formData.temporary_address
          : `${detailedAddress}, ${
              wards.find((ward) => ward.id == selectedWard).name
            }, ${
              districts.find((district) => district.id == selectedDistrict).name
            }, ${
              provinces.find((province) => province.id == selectedProvince).name
            }`,
      permanent_address:
        detailedAddress2 == ""
          ? formData.permanent_address
          : `${detailedAddress2}, ${
              wards2.find((ward) => ward.id == selectedWard2).name
            }, ${
              districts2.find((district) => district.id == selectedDistrict2)
                .name
            }, ${
              provinces2.find((province) => province.id == selectedProvince2)
                .name
            }`,
      issued_by: formData.issued_by,
      recuitment_position_id: formData.recuitment_position_id,
      bank_name: formData.bank_name,
      bank_number: formData.bank_number,
      bank_account_name: formData.bank_account_name,
    };

    axios
      .put(`https://api.comnieuthienly.vn/api/finish-cv/${id}`, dataSend)
      .then((response) => {
        setLoading(false);
        setTimeout(() => setError(null), 90000);
        // Redirect to result page
        navigate("/done-success");
        console.log("Response:", response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
        setError("Có lỗi xảy ra khi gửi dữ liệu.");
        setTimeout(() => setError(null), 3000); // Hide error message after 3 seconds
      });

    setLoading(false);
  };

  // Fetch Tỉnh/Thành
  useEffect(() => {
    setLoading(true);
    axios
      .get("https://main.amhapy.com/api/place/vn/province")
      .then((response) => {
        const provinces = response?.data?.data || [];
        provinces.sort((a, b) => {
          if (a.id === 1) return -1; // Hà Nội first
          if (b.id === 1) return 1;
          if (a.id === 79) return -1; // Hồ Chí Minh second
          if (b.id === 79) return 1;
          return 0;
        });
        setProvinces(provinces);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching provinces:", error);
        setError("Có lỗi xảy ra khi lấy danh sách tỉnh/thành phố.");
        setLoading(false);
      });
  }, []);

  // Fetch Quận/Huyện khi tỉnh/thành thay đổi
  useEffect(() => {
    if (selectedProvince) {
      setLoading(true);
      axios
        .get(`https://main.amhapy.com/api/place/vn/district/${selectedProvince}`)
        .then((response) => {
          setDistricts(response?.data?.data || []);
          setSelectedDistrict(""); // Reset selected district
          setWards([]); // Reset wards
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
          setError("Có lỗi xảy ra khi lấy danh sách quận/huyện.");
          setLoading(false);
        });
    } else {
      setDistricts([]);
      setWards([]);
    }
  }, [selectedProvince]);

  // Fetch Xã/Phường khi quận/huyện thay đổi
  useEffect(() => {
    if (selectedDistrict) {
      setLoading(true);
      axios
        .get(`https://main.amhapy.com/api/place/vn/wards/${selectedDistrict}`)
        .then((response) => {
          setWards(response?.data?.data || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching wards:", error);
          setError("Có lỗi xảy ra khi lấy danh sách xã/phường.");
          setLoading(false);
        });
    } else {
      setWards([]);
    }
  }, [selectedDistrict]);

  // Fetch Tỉnh/Thành
  useEffect(() => {
    setLoading(true);
    axios
      .get("https://main.amhapy.com/api/place/vn/province")
      .then((response) => {
        const provinces = response?.data?.data || [];
        provinces.sort((a, b) => {
          if (a.id === 1) return -1; // Hà Nội first
          if (b.id === 1) return 1;
          if (a.id === 79) return -1; // Hồ Chí Minh second
          if (b.id === 79) return 1;
          return 0;
        });
        setProvinces2(provinces);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching provinces:", error);
        setError("Có lỗi xảy ra khi lấy danh sách tỉnh/thành phố.");
        setLoading(false);
      });
  }, []);

  // Fetch Quận/Huyện khi tỉnh/thành thay đổi
  useEffect(() => {
    if (selectedProvince2) {
      setLoading(true);
      axios
        .get(`https://main.amhapy.com/api/place/vn/district/${selectedProvince2}`)
        .then((response) => {
          setDistricts2(response?.data?.data || []);
          setSelectedDistrict2(""); // Reset selected district
          setWards2([]); // Reset wards
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
          setError("Có lỗi xảy ra khi lấy danh sách quận/huyện.");
          setLoading(false);
        });
    } else {
      setDistricts2([]);
      setWards2([]);
    }
  }, [selectedProvince2]);

  // Fetch Xã/Phường khi quận/huyện thay đổi
  useEffect(() => {
    if (selectedDistrict2) {
      setLoading(true);
      axios
        .get(`https://main.amhapy.com/api/place/vn/wards/${selectedDistrict2}`)
        .then((response) => {
          setWards2(response?.data?.data || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching wards:", error);
          setError("Có lỗi xảy ra khi lấy danh sách xã/phường.");
          setLoading(false);
        });
    } else {
      setWards2([]);
    }
  }, [selectedDistrict2]);

  const convertDateToYyyyMmDd = (dmyDate) => {
    if (!dmyDate || typeof dmyDate !== "string") return "";
    const parts = dmyDate.split("/");
    if (parts.length !== 3) return "";
    if (isNaN(parts[0]) || isNaN(parts[1]) || isNaN(parts[2])) return "";
    return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(
      2,
      "0"
    )}`;
  };

  const checkLegitFront = async (imageDataBase64, mimeType) => {
    if (!apiKey) {
      throw new Error("API Key của Gemini chưa được cấu hình.");
    }
    const ai = new GoogleGenAI({ apiKey });

    const imagePart = { inlineData: { mimeType, data: imageDataBase64 } };
    const textPart = {
      text:   `Hãy kiểm tra ảnh và trả về object
      Nếu ảnh có chữ "CĂN CƯỚC" thì nó là mặt trước thì trả về {front: true}
      Còn nếu ảnh có chữ 'IDVNM' thì trả về {front: false} và các trường hợp khác cũng trả về {front: false}
      `,
    };

    try {
      const response = await ai.models.generateContent({
        model: model,
        contents: { parts: [imagePart, textPart] },
        config: { responseMimeType: "application/json" },
      });

      let jsonStr = JSON.parse(response.text.trim());

      return jsonStr.front;
    } catch (e) {
      console.error("Lỗi khi gọi hoặc phân tích JSON từ Gemini:", e);
      toast.error("Có lỗi xảy ra. Vui lòng thử lại sau!")
    }
  };

  const checkNewCardFront = async (imageDataBase64, mimeType) => {
    if (!apiKey) {
      throw new Error("API Key của Gemini chưa được cấu hình.");
    }
    const ai = new GoogleGenAI({ apiKey });

    const imagePart = { inlineData: { mimeType, data: imageDataBase64 } };
    const textPart = {
      text:   `Hãy kiểm tra ảnh và trả về object
      Nếu ảnh có chữ “CĂN CƯỚC CÔNG DÂN” xác định là mặt trước và trả về { newCard: false }
      Nếu ảnh có chỉ có duy nhất chữ “CĂN CƯỚC” xác định là mặt trước và trả về { newCard: true }
      `,
    };

    try {
      const response = await ai.models.generateContent({
        model: model,
        contents: { parts: [imagePart, textPart] },
        config: { responseMimeType: "application/json" },
      });

      let jsonStr = JSON.parse(response.text.trim());

      return jsonStr.newCard;
    } catch (e) {
      console.error("Lỗi khi gọi hoặc phân tích JSON từ Gemini:", e);
      toast.error("Có lỗi xảy ra. Vui lòng thử lại sau!")
    }
  };

  const checkLegitBack = async (imageDataBase64, mimeType) => {
    if (!apiKey) {
      throw new Error("API Key của Gemini chưa được cấu hình.");
    }
    const ai = new GoogleGenAI({ apiKey });

    const imagePart = { inlineData: { mimeType, data: imageDataBase64 } };
    const textPart = {
      text:   `Hãy kiểm tra ảnh và trả về object
      Nếu ảnh có chữ 'IDVNM' thì trả về {back: true}
      Còn nếu ảnh có chữ "CĂN CƯỚC" thì nó là mặt trước thì trả về {back: false} và các trường hợp khác cũng trả về {back: false}
      `,
    };

    try {
      const response = await ai.models.generateContent({
        model: model,
        contents: { parts: [imagePart, textPart] },
        config: { responseMimeType: "application/json" },
      });

      let jsonStr = JSON.parse(response.text.trim());

      return jsonStr.back;
    } catch (e) {
      console.error("Lỗi khi gọi hoặc phân tích JSON từ Gemini:", e);
      toast.error("Có lỗi xảy ra. Vui lòng thử lại sau!")
    }
  };

  const checkNewCardBack = async (imageDataBase64, mimeType) => {
    if (!apiKey) {
      throw new Error("API Key của Gemini chưa được cấu hình.");
    }
    const ai = new GoogleGenAI({ apiKey });

    const imagePart = { inlineData: { mimeType, data: imageDataBase64 } };
    const textPart = {
      text:   `Hãy kiểm tra ảnh và trả về object
      Nếu ảnh có mã QR thì trả về { newCard: true }
      Còn không thì trả về { newCard: false }
      `,
    };

    try {
      const response = await ai.models.generateContent({
        model: model,
        contents: { parts: [imagePart, textPart] },
        config: { responseMimeType: "application/json" },
      });

      let jsonStr = JSON.parse(response.text.trim());

      return jsonStr.newCard;
    } catch (e) {
      console.error("Lỗi khi gọi hoặc phân tích JSON từ Gemini:", e);
      toast.error("Có lỗi xảy ra. Vui lòng thử lại sau!")
    }
  };
  

  const extractInfoWithGemini = async (imageDataBase64, mimeType, name, type) => {
    if (!apiKey) {
      throw new Error("API Key của Gemini chưa được cấu hình.");
    }
    const ai = new GoogleGenAI({ apiKey });

    const imagePart = { inlineData: { mimeType, data: imageDataBase64 } };
    let textPart;

    // Prompt được cập nhật để yêu cầu Gemini xác định mặt thẻ
    if (name === "cmnd_front" && type === false) {
      textPart = {
        text: ` Chỉ trích xuất và trả về đối tượng JSON các trường sau nếu có:
                hoTen: Họ tên (viết hoa chữ cái đầu)
                soCCCD: Số CCCD/CMND
                ngaySinh: DD/MM/YYYY
                gioiTinh: Nam hoặc Nữ
                noiThuongTru: Địa chỉ thường trú
              `,
      };
    } else if (name === "cmnd_front" && type === true) {
      textPart = {
        text: ` Chỉ trích xuất và trả về đối tượng JSON các trường sau nếu có:
                hoTen: Họ tên (viết HOA)
                soCCCD: Số CCCD/CMND
                ngaySinh: DD/MM/YYYY
                gioiTinh: Nam hoặc Nữ
              `,
      };
    } else if (name === "cmnd_back_side" && type == false) {
      textPart = {
        text: ` Chỉ trích xuất và trả về đối tượng JSON các trường sau nếu có:
                ngayCap: DD/MM/YYYY
                Tuyệt đối không trả về mảng
              `,
      };
    } else if (name === "cmnd_back_side" && type == true) {
      textPart = {
        text: ` Chỉ trích xuất và trả về đối tượng JSON các trường sau nếu có:
                ngayCap: DD/MM/YYYY
                noiThuongTru: Địa chỉ cư trú
              `,
      };
    }

    try {
      const response = await ai.models.generateContent({
        model: model,
        contents: { parts: [imagePart, textPart] },
        config: { responseMimeType: "application/json" },
      });

      let jsonStr = response.text.trim();
      const fenceRegex = /^```(?:json)?\s*\n?(.*?)\n?\s*```$/s;
      const match = jsonStr.match(fenceRegex);
      if (match && match[1]) {
        jsonStr = match[1].trim();
      }

      return JSON.parse(jsonStr);
    } catch (e) {
      handleRemoveBackFile();
      handleRemoveFrontFile();
      console.error("Lỗi khi gọi hoặc phân tích JSON từ Gemini:", e);
      throw new Error(`Đã có lỗi xảy ra vui lòng thử lại`);
    }
  };

  const handleRemoveBackFile = () => {
    setFileBack(null);
    setPreviewUrlBack(null);
    document.getElementById("cmnd_back_side").value = "";
    setFormData((prev) => ({
      ...prev,
      date_range: "",
    }));
    setIsBack(true);
  };

  const handleRemoveFrontFile = () => {
    setFileFront(null);
    setPreviewUrlFront(null);
    document.getElementById("cmnd_front").value = "";
    setFormData((prev) => ({
      ...prev,
      cccd: "",
      permanent_address: "",
    }));
    setIsFront(true);
  };

  // Hàm nén ảnh
  const compressImage = (file, maxWidth = 1200, maxHeight = 1200, quality = 0.9) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        // Tính toán kích thước mới giữ nguyên tỷ lệ
        let { width, height } = img;
        
        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Vẽ ảnh lên canvas với kích thước mới
        ctx.drawImage(img, 0, 0, width, height);
        
        // Chuyển đổi canvas thành blob
        canvas.toBlob(resolve, 'image/jpeg', quality);
      };
      
      img.src = URL.createObjectURL(file);
    });
  };

  const handleFileChange = async (event) => {
    const { name, files } = event.target;
    const file = files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      toast.error(
        "File quá lớn. Vui lòng chọn ảnh có kích thước tối đa 10 MB."
      );
      return;
    }

    // Nén ảnh trước khi upload
    let processedFile = file;

    try {
      
      // Chỉ nén nếu file > 1Mb
      if (file.size > 1 * 1024 * 1024) {
        toast.info("Đang tối ưu hóa hình ảnh...");
        const compressedBlob = await compressImage(file);
        
        // Tạo file mới từ blob đã nén
        processedFile = new File([compressedBlob], file.name, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });
        
        console.log(`Kích thước gốc: ${(file.size / 1024).toFixed(1)}KB -> Sau nén: ${(processedFile.size / 1024).toFixed(1)}KB`);
        // toast.success(`Tối ưu hóa thành công: ${(file.size / 1024).toFixed(1)}KB → ${(processedFile.size / 1024).toFixed(1)}KB`);
      }

      // Logic tải ảnh lên server với file đã được nén
      const uploadFormData = new FormData();
      uploadFormData.append("file", processedFile);
      
      const uploadResponse = await axios.post(
        `https://datatl.comnieuthienly.vn/upload/file?type=cccd`,
        uploadFormData,
        {
          headers: { 
            "Content-Type": "multipart/form-data",
            "token": "Hpjdrxt41idNG5xlZVieey4l8KMKowcgN4BXYAIrOsdd5xBxnKD1hLyCVFN7"
          },
        }
      );
      
      // Cấu trúc response mới: data.data.fileUrl (relative path)
      const fileUrl = uploadResponse?.data?.data?.fileUrl;
      const fullImageUrl = fileUrl 
        ? `https://datatl.comnieuthienly.vn/${fileUrl}` 
        : null;
      
      setFormData((prevState) => ({
        ...prevState,
        [name]: fullImageUrl,
      }));
      
    } catch (error) {
      console.log("error: ", error);
      toast.error("Lỗi khi tải ảnh lên máy chủ.");
      return;
    }

    if (!process.env.REACT_APP_GEMINI_API_KEY) {
      toast.warn(
        "Chức năng trích xuất tự động chưa được cấu hình (thiếu API Key)."
      );
      if (name === "cmnd_front") setIsFront(false);
      if (name === "cmnd_back_side") setIsBack(false);
      setIsExtracting(false);
      return;
    }

    const reader = new FileReader();

    if (name === "cmnd_front") {
      setFileFront(processedFile);
      if (processedFile && processedFile.type.startsWith("image/")) {
        setPreviewUrlFront(URL.createObjectURL(processedFile));
      }
      setIsExtracting(true);
      toast.info("Đang nhận dạng và trích xuất thông tin từ ảnh...");

      reader.onloadend = async () => {
        try {
          const base64String = reader.result.split(",")[1];
          const mimeType = processedFile.type;

          const isFrontCard = await checkLegitFront(base64String, mimeType);
          console.log("isFrontCard: ", isFrontCard);          

          if (!isFrontCard) {
            toast.warn("Không xác định được mặt trước, vui lòng tự nhập thông tin.");
            setIsFront(false);
            return;
          }

          const newCard = await checkNewCardFront(base64String, mimeType);

          if (cardType.back !== null && newCard !== cardType.back) {
            toast.warn("Không xác định cùng loại thẻ, vui lòng tự nhập thông tin.");
            setIsFront(false);
            return;
         }
         setCardType(prev => ({ ...prev, front: newCard }));
          

          const info = await extractInfoWithGemini(
            base64String,
            mimeType,
            name,
            newCard
          );
          console.log("info: ", info);

          if (newCard === true) {
            setFormData((prev) => ({
              ...prev,
              name: info.hoTen ? capitalizeName(info.hoTen) : prev.name,
              cccd: info.soCCCD || prev.cccd,
              birthday: convertDateToYyyyMmDd(info.ngaySinh) || prev.birthday,
              sex:
                info.gioiTinh === "Nam"
                  ? 1
                  : info.gioiTinh === "Nữ"
                  ? 2
                  : prev.sex,
            }));
          } else {
            setFormData((prev) => ({
              ...prev,
              name: info.hoTen ? capitalizeName(info.hoTen) : prev.name,
              cccd: info.soCCCD || prev.cccd,
              birthday: convertDateToYyyyMmDd(info.ngaySinh) || prev.birthday,
              sex:
                info.gioiTinh === "Nam"
                  ? 1
                  : info.gioiTinh === "Nữ"
                  ? 2
                  : prev.sex,
              permanent_address: info.noiThuongTru || prev.permanent_address,
            }));
          }

          toast.success("Trích xuất thông tin mặt trước thành công!");
          setIsFront(false);
        } catch (err) {
          toast.warn("Không thể trích xuất tự động, vui lòng nhập tay.");
          setIsFront(false);
        } finally {
          setIsExtracting(false);
        }
      };
      reader.readAsDataURL(processedFile);
    } else if (name === "cmnd_back_side") {
      setFileBack(processedFile);
      if (processedFile && processedFile.type.startsWith("image/")) {
        setPreviewUrlBack(URL.createObjectURL(processedFile));
      }
      setIsExtracting(true);
      toast.info("Đang nhận dạng và trích xuất thông tin từ ảnh...");

      reader.onloadend = async () => {
        try {
          const base64String = reader.result.split(",")[1];
          const mimeType = processedFile.type;

          const isBackCard = await checkLegitBack(base64String, mimeType);
          console.log("isBackCard: ", isBackCard);

          if (!isBackCard) {
            toast.warn("Không xác định được mặt sau, vui lòng tự nhập thông tin.");
            setIsBack(false);
            return;
          }

          const newCard = await checkNewCardBack(base64String, mimeType);
          console.log("newCard: ", newCard);

          if (cardType.front !== null && newCard !== cardType.front) {
            toast.warn("Không xác định cùng loại thẻ, vui lòng tự nhập thông tin.");
            setIsBack(false);
            return;
         }
         setCardType(prev => ({ ...prev, back: newCard }));

          const info = await extractInfoWithGemini(
            base64String,
            mimeType,
            name,
            newCard
          );
          console.log("info: ", info);


          if (newCard === true) {
            setFormData((prev) => ({
              ...prev,
              date_range: convertDateToYyyyMmDd(info.ngayCap) || prev.date_range,
              permanent_address: info.noiThuongTru || prev.permanent_address,
            }));
          } else {
            setFormData((prev) => ({
              ...prev,
              date_range: convertDateToYyyyMmDd(info.ngayCap) || prev.date_range,
            }));
          }

          toast.success("Trích xuất thông tin mặt sau thành công!");
          setIsBack(false);
        } catch (err) {
          toast.warn("Không thể trích xuất tự động, vui lòng nhập tay.");
          setIsBack(false);
        } finally {
          setIsExtracting(false);
        }
      };
      reader.readAsDataURL(processedFile);
    }
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get("https://api.comnieuthienly.vn/api/form-cv")
      .then((response) => {
        const data = response?.data?.data;
        setPositions(data?.positions || []);
        setAreas(data?.areas || []);
        console.log("data", data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Có lỗi xảy ra khi lấy dữ liệu.");
        setLoading(false);
      });
  }, []);

  const fetchDataCVInfo = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.comnieuthienly.vn/api/cv-info/${id}`
      );
      const apiData = response.data.data || {};
      // Chuẩn hóa họ tên ngay khi nhận từ API
      const normalizedData = {
        ...apiData,
        name: capitalizeName(apiData.name),
      };
      setFormData(normalizedData); // Cập nhật state với dữ liệu đã chuẩn hóa
    } catch (err) {
      console.error("Error fetching data:", err);
      setTimeout(() => {
        setError("");
      }, 2000);
      setError("Có lỗi xảy ra khi lấy dữ liệu.");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchDataCVInfo(); // Gọi api khi component mount
  }, [fetchDataCVInfo]);

  if (showProfileIntro) {
    return (
      <EmployeeProfileDirectory
        embedded
        onContinue={() => setShowProfileIntro(false)}
      />
    );
  }

  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center mb-8">
        <div className="banner-img card-banner"></div>
        <div className="wrap-content" style={{ marginBottom: 0 }}>
          <div className="line"></div>
          <div className="text">
            <span className="text-heading">
              CUNG CẤP THÔNG TIN NHÂN VIÊN MỚI
            </span>
            <div className="line-top"></div>
            <p className="text-requied">* Chỉ ra những câu hỏi bắt buộc</p>
          </div>
        </div>
        <div className="wrap-content" style={{ marginBottom: 0 }}>
          <div
            className="line"
            style={{ padding: "12px 24px", height: "auto" }}
          >
            <span
              className="text-content"
              style={{ color: "rgb(0, 0, 0)", fontSize: "12pt" }}
            >
              THÔNG TIN CÁ NHÂN
            </span>
          </div>
          <div className="text-content" style={{ marginTop: "50px" }}>
            Các thông tin bạn cung cấp làm cơ sở để lưu trữ dữ liệu nhân sự, do
            đó, hãy nhập chính xác nhé.
          </div>
        </div>
        <div className="wrap-card">
          <form className="flex flex-col gap-4 mt-6" onSubmit={handleSubmit}>
            {/* Họ và tên */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="name">
                Họ Và Tên (Viết hoa chữ cái đầu. Ví dụ: Nguyễn Văn A)
                <span className="style-required" aria-label="Required question">
                  *
                </span>
              </label>
              <input
                type="text"
                name="name"
                required
                value={formData?.name || ''}
                onChange={handleChange}
                className="form-input"
                placeholder="Nhập họ và tên"
              />
            </div>

            {/* Ngày tháng năm sinh */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="dob">
                NGÀY, THÁNG, NĂM SINH
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="date"
                name="birthday"
                value={formatDateVN(formData?.birthday) || ""}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            {/* Số điện thoại */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="phone">
                SỐ ĐIỆN THOẠI
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="number"
                name="phone"
                value={formData?.phone}
                onChange={handleChange}
                required
                className="form-input"
                pattern="[0-9]{10}"
                placeholder="Nhập số điện thoại"
              />
            </div>

            {/* Giới tính */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="sex">
                GIỚI TÍNH
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <label className="mr-5 flex items-center">
                <input
                  type="radio"
                  name="sex"
                  value={1}
                  checked={formData.sex == 1}
                  onChange={handleRadioChange}
                  required
                />
                Nam
              </label>
              <label className="mr-5 flex items-center">
                <input
                  type="radio"
                  name="sex"
                  value={2}
                  checked={formData.sex == 2}
                  onChange={handleRadioChange}
                  required
                />
                Nữ
              </label>
            </div>
            {/* Email */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="email">
                EMAIL
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="email"
                name="email"
                value={formData?.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            {/* MST */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="mst">
                MÃ SỐ THUẾ CÁ NHÂN
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="number"
                name="mst"
                value={formData?.mst}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            {/* cmnd */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="cmnd">
                Số CMND cũ (9 số)
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="number"
                name="cmnd"
                value={formData?.cmnd}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="grid grid-cols-12 gap-4">
              {/* Upload ảnh mặt trước cccd */}
              <div className="form-group  col-span-12 sm:col-span-6">
                <label
                  className="text-style display--block"
                  htmlFor="cmnd_front"
                >
                  Mặt trước CCCD/CMND
                  <span
                    className="style-required"
                    aria-label="Required question"
                  >
                    {" "}
                    *
                  </span>
                </label>
                <input
                  type="file"
                  name="cmnd_front"
                  id="cmnd_front"
                  accept="image/*"
                  onChange={handleFileChange}
                  required
                  className="form-input"
                />

                {fileFront && (
                  <div className="mt-2 relative transition-all delay-200">
                    {previewUrlFront && (
                      <img
                        src={previewUrlFront}
                        alt="Preview"
                        className="w-full rounded shadow"
                      />
                    )}
                    <div className="absolute top-2 right-2 cursor-pointer">
                      <button
                        type="button"
                        disabled={isExtracting}
                        onClick={handleRemoveFrontFile}
                        className="bg-black rounded-full flex items-center justify-center w-7 h-7 p-0"
                      >
                        <IoClose size={25} className="text-white" />
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Upload ảnh mặt sau cccd */}
              <div className="form-group col-span-12 sm:col-span-6">
                <label
                  className="text-style display--block"
                  htmlFor="cmnd_back_side"
                >
                  Mặt sau CCCD/CMND
                  <span
                    className="style-required"
                    aria-label="Required question"
                  >
                    {" "}
                    *
                  </span>
                </label>
                <input
                  type="file"
                  name="cmnd_back_side"
                  id="cmnd_back_side"
                  onChange={handleFileChange}
                  required
                  className="form-input"
                />

                {fileBack && (
                  <div className="mt-2 relative transition-all delay-200">
                    {previewUrlBack && (
                      <img
                        src={previewUrlBack}
                        alt="Preview"
                        className="w-full rounded shadow"
                      />
                    )}
                    <div
                      disabled={isExtracting}
                      onClick={handleRemoveBackFile}
                      className="absolute top-2 right-2 cursor-pointer"
                    >
                      <button
                        type="button"
                        disabled={isExtracting}
                        onClick={handleRemoveBackFile}
                        className="bg-black rounded-full flex items-center justify-center w-7 h-7 p-0"
                      >
                        <IoClose size={25} className="text-white" />
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {isExtracting && (
                <div className="text-blue-600 flex items-center col-span-12">
                  <div className="loader-small"></div>
                  Đang phân tích ảnh, vui lòng chờ...
                </div>
              )}
            </div>

            {!isFront && !isBack && (
              <>
                {/* cmnd mới*/}
                <div className={`form-group`}>
                  <label className="text-style display--block" htmlFor="cccd">
                    Căn Cước Công Dân (12 số)
                    <span
                      className="style-required"
                      aria-label="Required question"
                    >
                      {" "}
                      *
                    </span>
                  </label>
                  <input
                    type="text"
                    inputMode="numeric"
                    autoComplete="off"
                    name="cccd"
                    value={formData?.cccd}
                    onChange={handleChange}
                    maxLength={12}
                    required
                    className="form-input"
                  />
                </div>

                {/* Ngày cấp */}
                <div className={`form-group`}>
                  <label
                    className="text-style display--block"
                    htmlFor="date_range"
                  >
                    NGÀY CẤP
                    <span
                      className="style-required"
                      aria-label="Required question"
                    >
                      {" "}
                      *
                    </span>
                  </label>
                  <input
                    type="date"
                    name="date_range"
                    value={formatDateVN(formData?.date_range)}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>

                {/* Nơi cấp */}
                <div className={`form-group`}>
                  <label
                    className="text-style display--block"
                    htmlFor="issued_by"
                  >
                    NƠI CẤP
                    <span
                      className="style-required"
                      aria-label="Required question"
                    >
                      {" "}
                      *
                    </span>
                  </label>
                  <input
                    type="text"
                    name="issued_by"
                    value={formData?.issued_by}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>

                {/* Địa chỉ thường trú */}
                <div className={`form-group`}>
                  <label
                    className="text-style display--block"
                    htmlFor="permanent_address"
                  >
                    ĐỊA CHỈ THƯỜNG TRÚ (KHÔNG VIẾT TẮT & GHI NHƯ CMND/CCCD)
                    <span
                      className="style-required"
                      aria-label="Required question"
                    >
                      {" "}
                      *
                    </span>
                  </label>
                  {!show2 && (
                    <textarea
                      type="text"
                      name="permanent_address"
                      onClick={() => {
                        setShow2(!show2);
                      }}
                      value={formData?.permanent_address}
                      onChange={handleChange}
                      required
                      className="form-input"
                    />
                  )}
                  {show2 && (
                    <>
                      <div className="form-group">
                        <select
                          id="province2"
                          class="form-input"
                          name="province2"
                          value={selectedProvince2}
                          onChange={(e) => setSelectedProvince2(e.target.value)}
                          required
                        >
                          <option value="">Chọn Tỉnh/Thành</option>
                          {provinces2.map((province) => (
                            <option key={province.id} value={province.id}>
                              {province.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Quận/Huyện */}
                      <div className="form-group">
                        <select
                          id="district2"
                          class="form-input"
                          name="district2"
                          value={selectedDistrict2}
                          onChange={(e) => setSelectedDistrict2(e.target.value)}
                          disabled={!selectedProvince2}
                          required
                        >
                          <option value="">Chọn Quận/Huyện</option>
                          {districts2.map((district) => (
                            <option key={district.id} value={district.id}>
                              {district.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Xã/Phường */}
                      <div className="form-group">
                        <select
                          id="ward2"
                          class="form-input"
                          name="ward2"
                          value={selectedWard2}
                          onChange={(e) => setSelectedWard2(e.target.value)}
                          disabled={!selectedDistrict2}
                          required
                        >
                          <option value="">Chọn Xã/Phường</option>
                          {wards2.map((ward) => (
                            <option key={ward.id} value={ward.id}>
                              {ward.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Địa chỉ chi tiết */}
                      <div className="form-group">
                        <label
                          style={{ paddingLeft: "15px" }}
                          htmlFor="detailedAddress2"
                        >
                          Địa chỉ chi tiết
                          <span
                            className="style-required"
                            aria-label="Required question"
                          >
                            {" "}
                            *
                          </span>
                        </label>
                        <textarea
                          type="text"
                          name="detailedAddress2"
                          value={detailedAddress2} // Gắn giá trị của detailedAddress vào input
                          onChange={(e) => {
                            setDetailedAddress2(e.target.value);
                          }} // Sử dụng hàm handleAddressChange để lưu giá trị
                          className="form-input"
                          placeholder="Nhập địa chỉ chi tiết"
                          required
                        />
                      </div>
                    </>
                  )}
                </div>

                {/* Địa chỉ tạm trú */}
                <div className={`form-group`}>
                  <div className="flex flex-row content-start items-baseline">
                    <label
                      class="text-style display--block mr-5"
                      for="province"
                    >
                      ĐỊA CHỈ TẠM TRÚ
                      <span
                        class="style-required"
                        aria-label="Required question"
                      >
                        {" "}
                        *
                      </span>
                    </label>
                  </div>
                  {!show && (
                    <textarea
                      onClick={() => {
                        setShow(!show);
                      }}
                      type="text"
                      name="detailedAddress"
                      value={formData.temporary_address} // Gắn giá trị của detailedAddress vào input
                      onChange={handleAddressChange} // Sử dụng hàm handleAddressChange để lưu giá trị
                      className="form-input"
                      placeholder="Nhập địa chỉ tạm trú"
                      required
                    />
                  )}
                  {show && (
                    <>
                      <div className="form-group">
                        <select
                          id="province"
                          class="form-input"
                          name="province"
                          value={selectedProvince}
                          onChange={(e) => setSelectedProvince(e.target.value)}
                          required
                        >
                          <option value="">Chọn Tỉnh/Thành</option>
                          {provinces.map((province) => (
                            <option key={province.id} value={province.id}>
                              {province.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <select
                          id="district"
                          class="form-input"
                          name="district"
                          value={selectedDistrict}
                          onChange={(e) => setSelectedDistrict(e.target.value)}
                          disabled={!selectedProvince}
                          required
                        >
                          <option value="">Chọn Quận/Huyện</option>
                          {districts.map((district) => (
                            <option key={district.id} value={district.id}>
                              {district.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <select
                          id="ward"
                          class="form-input"
                          name="ward"
                          value={selectedWard}
                          onChange={(e) => setSelectedWard(e.target.value)}
                          disabled={!selectedDistrict}
                          required
                        >
                          <option value="">Chọn Xã/Phường</option>
                          {wards.map((ward) => (
                            <option key={ward.id} value={ward.id}>
                              {ward.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label
                          style={{ paddingLeft: "15px" }}
                          htmlFor="detailedAddress"
                        >
                          Địa chỉ chi tiết
                          <span
                            className="style-required"
                            aria-label="Required question"
                          >
                            {" "}
                            *
                          </span>
                        </label>
                        <textarea
                          type="text"
                          name="detailedAddress"
                          value={detailedAddress} // Gắn giá trị của detailedAddress vào input
                          onChange={handleAddressChange} // Sử dụng hàm handleAddressChange để lưu giá trị
                          className="form-input"
                          placeholder="Nhập địa chỉ chi tiết"
                          required
                        />
                      </div>
                    </>
                  )}
                </div>
              </>
            )}

            {/* Ngày nhận việc */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="startDay">
                NGÀY NHẬN VIỆC
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="date"
                name="start"
                value={formData.start}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <p>
              Hệ thống Thiên Lý hiện đang trả lương thông qua tài khoản
              ngân hàng Techcombank.
              Trước kỳ chi lương tháng đầu tiên, bạn vui lòng mở thẻ Techcombank
              theo quy định công ty.
            </p>

            {/* số tk ngân hàng */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="cmnd">
                Số tài khoản ngân hàng
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="number"
                name="bank_number"
                value={formData?.bank_number}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            {/* cmnd */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="cmnd">
                Họ và tên chủ tài khoản
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="text"
                name="bank_account_name"
                value={formData?.bank_account_name}
                onChange={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                  handleChange(e);
                }}
                required
                className="form-input"
              />
            </div>

            {/* cmnd */}
            <div className="form-group">
              <label className="text-style display--block" htmlFor="cmnd">
                Ngân hàng thụ hưởng
                <span className="style-required" aria-label="Required question">
                  {" "}
                  *
                </span>
              </label>
              <input
                type="text"
                name="bank_name"
                value={formData?.bank_name}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            {/* Submit Button */}
            <div className="flex flex-row content-start items-center">
              <button style={{ marginRight: "25px" }}>
                <Link to={"/danh-muc-ho-so-nhan-vien"}>Trở lại</Link>
              </button>
              <button
                type="submit"
                style={{ backgroundColor: "#e35522", color: "#fff" }}
              >
                Gửi
              </button>
              {loading && <div class="loader"></div>}
              {error && (
                <div id="errorPopup" className="error-popup">
                  {error}
                </div>
              )}
            </div>
          </form>
        </div>
        <a
          className="style-link flex flex-row items-center justify-center"
          href="https://comnieuthienly.vn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            style={{
              aspectRatio: "auto 74 / 24",
              width: "200px",
            }}
            src="https://i.imgur.com/nB8LOLM.png"
            alt="img-logo-thien-ly"
          />
        </a>
      </div>
      {/* Loading spinner */}
      <div id="loadingSpinner" className="hidden">
        Đang xử lý...
      </div>

      {/* Error notification */}
      <div id="errorPopup" className="hidden">
        <p>Đã xảy ra lỗi khi gửi dữ liệu. Vui lòng thử lại.</p>
      </div>
    </div>
  );
};

export default ProvideInfoEmployee;
